// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyView_container__3ijpY","icon":"EmptyView_icon__2VPe_","text":"EmptyView_text__4xdxA"};